namespace Matrix.Administration {
    export namespace AboutService {
        export const baseUrl = 'About';

        export declare function About(request: Serenity.ServiceRequest, onSuccess?: (response: AboutResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            About = "About/About"
        }

        [
            'About'
        ].forEach(x => {
            (<any>AboutService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
